import React, { useContext } from 'react';
import { BaseItem } from './BaseItem';
import { Context } from './Context';

export interface LabelItemProps {
  label: string;
}

export const LabelItem: React.FunctionComponent<LabelItemProps> = ({ label }) => {
  const { testId } = useContext(Context);

  return (
    <BaseItem data-component="InfoListLabelItem" testId={`${testId}-labelItem`}>
      {label}
    </BaseItem>
  );
};
